import { AddButton, Header, Page, Toolbox } from 'redesign';
import { useTranslation } from 'react-i18next';
import { WorkflowsTableDataProvider } from './workflow-table/workflows-table';

export function WorkflowDashboard() {
  const { t } = useTranslation('ogp-screen-specific');

  return (
    <Page
      header={<Header titleText={t('workflows.title', { ns: 'ogp-screen-specific' })} />}
      toolbox={
        <Toolbox>
          <AddButton>{t('workflows.add_workflow', { ns: 'ogp-screen-specific' })}</AddButton>
        </Toolbox>
      }
    >
      <WorkflowsTableDataProvider />
    </Page>
  );
}
